import { Component, Input, OnInit } from '@angular/core';

import { CaArea, CaGroup } from '../../../core';
import { updateScores } from '../../../dialog/function/handle-check-list.function';
import { createNewMyFocusPhaseHandle } from '../../function/create-handle.function';
import { setFocusPhrase } from '../../function/set-focus-phrase.function';
import { currentState } from '../../state';
import { State } from '../../state.model';

@Component({
    selector: 'cmps-ca-evaluation-focus',
    templateUrl: './focus.component.html',
})
export class FocusComponent implements OnInit {
    @Input()
    group: CaGroup;

    @Input()
    area: CaArea;

    /** @private */
    _state: State;

    /** @private */
    _showIcaPhrases: boolean;

    /** @private */
    _icaPhrases: string[][];

    constructor() {
        this._state = currentState();

        this._icaPhrases = [
            [
                "Let me make sure I've got this right - what specifically  are you committing to, and by when?",
                'COMPAS ICA generated',
            ],
            [
                "I want to make sure we're leaving today with something concrete. What's the one thing you're going to do differently this week?",
                'COMPAS ICA generated',
            ],
            [
                "Before we wrap up, tell me exactly what you're going to do - in your own words.",
                'System',
            ],
            [
                "We're focused on moving your Sales Conversion % from 14.1% toward 18.5%. What's your commitment for the next week?",
                'COMPAS ICA generated',
            ],
        ];
    }

    ngOnInit(): void {
        if (
            this._state.caResult?.guideConfigId?.toLowerCase()?.trim() ===
                'fordraft' &&
            this.group?.label?.toLowerCase()?.trim() === 'open'
        ) {
            this._icaPhrases = [
                [
                    'Hey, thanks for making the time. Before we get into anything, how are things going for you?',
                    'COMPAS ICA generated',
                ],
                [
                    "I want to use today to look at this KPI together for the first time. I don't have conclusions, I want your read first.",
                    'COMPAS ICA generated',
                ],
                [
                    "Here's what I'd like to cover: where this KPI sits right now, what you're running into on your interactions, and one thing we could try. Does that work?",
                    'COMPAS ICA generated',
                ],
                [
                    "Nothing here is decided in advance. This is a conversation, and you'll have as much say in where we land as I do.",
                    'COMPAS ICA generated',
                ],
            ];
        }

        if (
            this._state.caResult?.guideConfigId?.toLowerCase()?.trim() ===
                'fordraft' &&
            this.group?.label?.toLowerCase()?.trim() === 'explore'
        ) {
            this._icaPhrases = [
                [
                    "Before I show you anything, how do you think you're tracking on this KPI right now?",
                    'COMPAS ICA generated',
                ],
                [
                    "You're sitting at this current value against this target, which puts you at this percent to target. What's your reaction to that?",
                    'COMPAS ICA generated',
                ],
                [
                    'Think about your last handful of calls. Where in the conversation does it get hardest for you?',
                    'COMPAS ICA generated',
                ],
                [
                    "That's a bit different from how you just described it. Tell me more about where the gap might be.",
                    'COMPAS ICA generated',
                ],
                [
                    'Is there a type of customer, or a type of call, where you feel less sure of yourself?',
                    'COMPAS ICA generated',
                ],
            ];
        }

        if (
            this._state.caResult?.guideConfigId?.toLowerCase()?.trim() ===
                'fordraft' &&
            this.group?.label?.toLowerCase()?.trim() === 'support'
        ) {
            this._icaPhrases = [
                [
                    "From what you've described, it sounds like the moment to work on is the one you just walked me through. Have I got that right?",
                    'COMPAS ICA generated',
                ],
                [
                    'If we picked one thing to focus on, what do you think would make the biggest difference for you?',
                    'COMPAS ICA generated',
                ],
                [
                    "I have a suggestion that's helped in similar situations. Can I put it to you, and you tell me whether it fits how you work?",
                    'COMPAS ICA generated',
                ],
                [
                    "Let's keep this to one change rather than five. Which one do you want to start with?",
                    'COMPAS ICA generated',
                ],
            ];
        }

        if (
            this._state.caResult?.guideConfigId?.toLowerCase()?.trim() ===
                'fordraft' &&
            this.group?.label?.toLowerCase()?.trim() === 'commit'
        ) {
            this._icaPhrases = [
                [
                    'So in your own words, what are you going to do differently on your next set of calls?',
                    'COMPAS ICA generated',
                ],
                [
                    'What does that actually sound like on a live call? Walk me through it.',
                    'COMPAS ICA generated',
                ],
                [
                    'What could get in the way of that this week, and how do we work around it?',
                    'COMPAS ICA generated',
                ],
                [
                    "How will you know it's working, before we even look at this KPI?",
                    'COMPAS ICA generated',
                ],
            ];
        }

        if (
            this._state.caResult?.guideConfigId?.toLowerCase()?.trim() ===
                'fordraft' &&
            this.group?.label?.toLowerCase()?.trim() === 'close'
        ) {
            this._icaPhrases = [
                [
                    "Let me play back what I heard, so you can correct me if I've got any of it wrong.",
                    'COMPAS ICA generated',
                ],
                [
                    "This is a starting point, not a verdict. We'll look at it together and adjust as we go.",
                    'COMPAS ICA generated',
                ],
                [
                    'What do you need from me between now and the next time we talk?',
                    'COMPAS ICA generated',
                ],
                [
                    "Let's put a short check-in in the calendar. Would Wednesday work?",
                    'COMPAS ICA generated',
                ],
            ];
        }
    }

    /** @private */
    _onCheckClick(): void {
        updateScores(this.area, this._state.caResult);
    }

    /** @private */
    _onAddMyPhraseClick(ref: HTMLElement): void {
        this._showIcaPhrases = false;
        createNewMyFocusPhaseHandle(this.area, ref);
    }

    /** @private */
    _onIcaPhraseClick(phrase: string[]): void {
        this._showIcaPhrases = false;
        setFocusPhrase(this.area, phrase[0]);
    }
}
